export const TEST_ROUTINE_COPY = {
	title: {
		add: 'Add routine test',
		edit: 'Edit routine test',
	},
	submit: {
		add: 'Add',
		edit: 'Save',
	},
	description:
		'Record the recurring tests or inspections that uphold product safety and compliance.',
	fields: {
		nameLabel: 'What is the test or check called?',
		nameDescription:
			'Pick a common test name or choose Other to describe your own method.',
		nameOtherLabel: 'How would you label this test on reports or SOPs?',
		frequencyLabel: 'How often do you run it?',
	},
}

export const ROUTINE_TEST_NAME_OPTIONS = [
	{ value: 'microbial_release', label: 'Microbiological release testing' },
	{
		value: 'preservative_challenge',
		label: 'Preservative efficacy (PET) challenge',
	},
	{
		value: 'stability_accelerated',
		label: 'Accelerated stability (e.g., 40°C/75% RH)',
	},
	{
		value: 'packaging_compatibility',
		label: 'Packaging compatibility / extractables-leachables',
	},
	{
		value: 'heavy_metals_screen',
		label: 'Heavy metals or contamination screening',
	},
	{ value: 'other', label: 'Other test or inspection' },
] as const

export const TEST_FREQUENCY_OPTIONS = [
	{ value: 'per_lot', label: 'Per production lot' },
	{ value: 'weekly', label: 'Weekly' },
	{ value: 'monthly', label: 'Monthly' },
	{ value: 'quarterly', label: 'Quarterly' },
	{ value: 'annually', label: 'Annually' },
	{ value: 'launch_only', label: 'At launch or formula change' },
] as const
